const categories = [
  "Mobiles",
  "Wallets / Purses",
  "Keys",
  "Documents / Certificates",
  "Bags / Luggage",
  "Electronics (Laptops, etc.)",
  "Jewelry / Ornaments",
  "Pets",
  "Vehicles",
  "Other"
];

export default categories;